import React from 'react';
import { X } from 'lucide-react';

interface Props {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: React.ReactNode;
  footer: React.ReactNode;
}

/** Moldura comum dos modais de NF (enviar, liberar, rejeitar). */
export const NFModalShell: React.FC<Props> = ({ title, subtitle, onClose, children, footer }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true">
    <div className="w-full max-w-lg rounded-xl bg-white shadow-xl">
      <div className="flex items-start justify-between border-b border-gray-200 px-6 py-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
          {subtitle && <p className="mt-0.5 text-sm text-gray-500">{subtitle}</p>}
        </div>
        <button type="button" onClick={onClose} className="text-gray-400 hover:text-gray-600" aria-label="Fechar">
          <X className="h-5 w-5" />
        </button>
      </div>
      <div className="space-y-4 px-6 py-5">{children}</div>
      <div className="flex justify-end gap-2 border-t border-gray-200 px-6 py-4">{footer}</div>
    </div>
  </div>
);

export const btnSecondary =
  'rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50';
export const btnPrimary =
  'inline-flex items-center gap-1.5 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50';
